import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TransactionInfoService } from 'src/app/services/transaction-info.service';
import { ClaimTypes } from 'src/app/model/claim-type.model';

@Component({
    selector: 'app-theft',
    templateUrl: './theft.component.html',
    styleUrls: ['./theft.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TheftComponent implements OnInit {

  constructor( private transactionInfoService: TransactionInfoService) {
      this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_MV_THEFT]);
  }

  ngOnInit() {
  }

}


